import { TUserType } from './types';

export const API_ENDPOINTS = Object.freeze({
  CUSTOMER_USERS: '/customer-users',
  USERS: '/users-all',
  WELLDESIGN_USERS: '/welldesign-users',
  USERS_DATASET: '/user/dataset',
  USERS_DATASET_TRANSFER: '/user/dataset/transfer',
  USERS_DATASET_DELETE: '/user/dataset/delete',
  USERS_EXTERNAL_EMAIL: '/user/external-identification',
  USER_CUSTOMERS: '/user-customers',
  EXTERNAL_USERS_REQUESTS: '/external-user-requests',
  EXTERNAL_USER_FROM_REQUEST: '/external-user-from-request',
});

export const USER_TYPES: TUserType[] = [
  'drillingEngineer',
  'completionEngineer',
  'sme',
  'manager',
  'student',
  'professor',
  'wellPlannner',
  'other'
];
